import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import AbmPlaybook from '../components/AbmPlaybook'

export default function CmoPlaybook2026() {
  return (
    <div>
      <Header1/>
      <AbmPlaybook/>
      <Footer/>
    </div>
  )
}
